<template>
  <div class="share">
    <div class="bdsharebuttonbox share_title" data-tag="share_1">
      <a
        class="weixin"
        @mouseover.stop.prevent="isShow"
        @mouseleave.stop.prevent="isHide"
        :style="{
        'backgroundColor': colorString.shareBg,
        'backgroundImage':(colorString.iconCor==1?`url('/static/share_wechat_black@2x.png')`:`url('/static/share_wechat_white@2x.png')`)}"
      >
        <!-- <img
          :src="colorString.iconCor==1?'/static/share_wechat_black.png':'/static/share_wechat_white.png'"
          alt
        />-->
      </a>
      <div class="box" v-if="exhibit"></div>
      <div id="qrcode" ref="qrcode"></div>
      <div @click="commShare('weibo')">
        <a :style="{'background': colorString.shareBg}">
          <img
            :src="colorString.iconCor==1?'/static/share_weibo_black@2x.png':'/static/share_weibo_white@2x.png'"
            alt
          />
        </a>
      </div>
      <div @click="commShare('qq')">
        <a :style="{'background': colorString.shareBg}">
          <img
            :src="colorString.iconCor==1?'/static/share_qq_black@2x.png':'/static/share_qq_white@2x.png'"
            alt
          />
        </a>
      </div>
      <a
        :style="{
        'backgroundColor': colorString.shareBg,
        'backgroundImage':(colorString.iconCor==1?`url('/static/share_fb_black@2x.png')`:`url('/static/share_fb_white@2x.png')`)}"
        data-cmd="fbook"
      ></a>
      <a
        :style="{
        'backgroundColor': colorString.shareBg,
        'backgroundImage':(colorString.iconCor==1?`url('/static/share_twitter_black@2x.png')`:`url('/static/share_twitter_white@2x.png')`)}"
        data-cmd="twi"
      ></a>
    </div>
    <div
      :style="{
      'backgroundColor': colorString.topBg,
      'backgroundImage':(colorString.iconCor==1?`url('/static/back_to_top_black@2x.png')`:`url('/static/back_to_top_white@2x.png')`)}"
      class="return-top"
      @click="goToTop"
    ></div>
  </div>
</template>

<script type="text/ecmascript-6">
import comm from "@/assets/comm.js";
import { imageUrl } from "@/util/filters.js";
import QRCode from "qrcodejs2";
export default {
  name: "share",
  data() {
    return {
      qrcode: null,
      exhibit: false
    };
  },
  props: {
    param: {
      type: Object,
      default: null
    },
    colorString: {
      type: Object,
      default: null
    }
  },
  // created() {
  //   this.$nextTick(() => {
  //     this.makeQrcode();
  //   });
  // },
  // watch: {
  //   "param.url"(value) {
  //     this.qrcode.makeCode(value);
  //   },
  //   deep: true
  // },
  components: { QRCode },
  beforeCreate() {
    window._bd_share_main = "";
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
    var param = {
      title: this.param.title,
      url: this.param.url,
      pic: this.param.pic
    };
    window._bd_share_config = {
      common: {
        bdSnsKey: {},
        bdText: param.title,
        bdDesc: param.title,
        bdUrl: param.url,
        bdMini: "2",
        bdMiniList: false,
        bdStyle: "1",
        bdSize: "28"
      },
      share: {}
    };
    const s = document.createElement("script");
    s.type = "text/javascript";
    //s.src = "/static/share/baidushare.js";
    s.src = "/static/api/js/share.js";
    document.body.appendChild(s);
  },
  methods: {
    makeQrcode() {
      this.qrcode = new QRCode(document.querySelector("#qrcode"), {
        width: 105,
        height: 105, // 高度
        text: this.param.url, // 二维码内容
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    isShow() {
      this.makeQrcode();
      this.exhibit = true;
    },
    isHide() {
      this.$refs.qrcode.innerHTML = "";
      this.exhibit = false;
    },
    goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    commShare(name) {
      var param = {};
      if (this.param != null) {
        param = {
          title: this.param.title,
          url: this.param.url,
          pic: this.param.pic
        };
        if (name == "weibo") {
          comm.shareToweibo(param);
        } else if (name == "qq") {
          comm.shareToQq(param);
        }
      }
    },
    showIcon() {
      var top = document.getElementsByClassName("return-top")[0];
      if (top) {
        if (
          document.documentElement.scrollTop &&
          document.documentElement.scrollTop > 400
        ) {
          top.style.display = "block";
        } else {
          top.style.display = "none";
        }
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.bdsharebuttonbox {
  display: inline-block;
  vertical-align: middle;
}

.return-top {
  background-size: 26px 26px;
  background-position: center;
  background-repeat: no-repeat;
  display: none;
  width: 50px;
  height: 50px;
}

.share {
  position: fixed;
  right: 10px;
  bottom: 114px;
  width: 50px;
  height: 315px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 999;

  .share_title {
    width: 100%;
    position: relative;

    a {
      background-size: 26px 26px;
      background-position: center;
      background-repeat: no-repeat;
      display: inline-block;
      height: 50px;
      width: 50px;
      line-height: 50px;
      padding: 0;
      // background-color: #44FC00;
      margin: 0 0 3px 0;
      text-align: center;

      img {
        width: 26px;
        height: 26px;
        display: inline-block;
      }
    }

    #qrcode {
      position: absolute;
      right: 74px;
      top: -26px;
    }

    .box {
      position: absolute;
      width: 146px;
      height: 137px;
      right: 50px;
      top: -42px;
      background: url('/static/share_qrcode_frame.png');
    }

    // a:nth-child(5) {
    //   margin: 0;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share.vue